import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from "react-redux";

import ModalCTA from '../modal/ModalCTA';
import ModalButton from '../modal/ModalButton';

import {
  setModal,
  saveLocalPlaylist
} from "../../../actions/index";

import {
  setEnablePM,
} from "./redux/actions/index";

function ButtonEnd({ closeRoom, leaveRoom, roomName }) {
  const dispatch = useDispatch();
  const isCohost = useSelector( state => (state.playersInRoomPM && state.playersInRoomPM.some(x => x.admin && !x.connect) && state.playersInRoomPM.some(x => x.id === state.user.id && x.cohost) ) );
  const isOwnerRoom = useSelector( state => !!(state.inRoomPM && state.user && state.inRoomPM.owner === state.user.id) );

  const onClick = () => {
    if (isOwnerRoom || isCohost) {
      const validClick = () => {
        dispatch(saveLocalPlaylist(Config.UID_SHARED_PLAYLIST, `${roomName}`))
        closeRoom();
        dispatch(setEnablePM(false));
      }
      dispatch(setModal({
        content: (
          <ModalCTA
            title={`Are you sure you want to end this set?`}
            description={`Set playlists will be saved automatically`}
            styleContainer={{marginTop: `-50%`, marginLeft: `-10%`}}
            classModal={`bottom-reduce`}
          >
            <ModalButton label={`End set`} className={`red-white`} onClick={validClick} />
            <ModalButton label={`Continue set`} className={`cancel`} />
          </ModalCTA>
        )
      }));
    } else {
      const quit = () => {
        leaveRoom(localStorage.getItem('a5RAW%93W!gph8'))();
      }
      const yesClick = () => {
        dispatch(saveLocalPlaylist(Config.UID_SHARED_PLAYLIST, `${roomName}`))
        quit();
      }

      dispatch(setModal({
        content: (
          <ModalCTA
            title={`Are you sure you want to exit this session?`}
            styleContainer={{marginTop: `-50%`, marginLeft: `-10%`}}
            classModal={`bottom-reduce`}
          >
            <ModalButton label={`Save playlist and leave`} className={`red-white`} onClick={yesClick} />
            <ModalButton label={`Leave party`} className={`transparent-grey`} onClick={quit} />
            <ModalButton label={`Cancel`} className={`cancel`} />
          </ModalCTA>
        ),
        underlayClickExits: false,
      }));
    }
  }

  return (
    <span className={'type-medium fz13 warning-red'}
      style={{ position: 'fixed', top: 14, left: (isOwnerRoom || isCohost) ? 155 : 145, visibility: 'initial', cursor: 'pointer'}} onClick={onClick} >
      { (isOwnerRoom || isCohost) ? 'End Set' : 'Leave Party' }
    </span>
  )
}

ButtonEnd.propTypes = {
  closeRoom: PropTypes.func.isRequired,
  leaveRoom: PropTypes.func.isRequired,
  roomName: PropTypes.string.isRequired
}

export default ButtonEnd;
